import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataView } from "primereact/dataview";
import { getUserData } from "../../utils/localStorage";
import { formatDate, formatDateNewWithTime, maskMobileNumber } from "../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DeliveryReturnRequest } from "../../services/StoreCustomerDeliveryRequest/updatePickupRequest";
import {
  updateDeliveryRequest,
  updatePickupRequest,
} from "../../services/StoreRiderInfo/StoreRiderInfo";
import SuccessModal from "../SuccessModal";
import PickupRequest from "../PickupAndDeliveryModal/PickupRequest";
import DeliveryRequest from "../PickupAndDeliveryModal/DeliveryRequest";

const JobRequests = ({ orderInfoData, JobType, storeId, callRequestApi }) => {
  const { userProfileRole } = getUserData();

  const userRole = userProfileRole;

  const [selectedItem, setSelectedItem] = useState(orderInfoData[0]?.id);
  const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);
  const [pickupRequestModalVisible, setPickupRequestModalVisible] =
    useState(false);
  const [deliveryRequestModalVisible, setDeliveryRequestModalVisible] =
    useState(false);
  const [selectedRiderDetails, setSelectedRiderDetails] = useState(null);
  const [pickupDeliveryRequestData, setPickupDeliveryRequestData] =
    useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");

  const handleItemPress = (item) => {
    setSelectedItem((prevSelectedItem) =>
      prevSelectedItem === item.id ? null : item.id
    );
    setSelectedItemForEdit(item.id);
    // Set the selected rider details when an item is pressed
    setSelectedRiderDetails(item.rider_details);
  };

  const onEdit = ({ pickupDeliveryRequestData }) => {
    if (JobType == "pickup") {
      setPickupRequestModalVisible(true);
    } else {
      setDeliveryRequestModalVisible(true);
    }
    setPickupDeliveryRequestData(pickupDeliveryRequestData);
    // Implement your edit functionality here using the itemId
    // You can navigate to an edit screen or perform any other action here.
  };

  const navigate = useNavigate();

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);
  const receiveResponse = ({ message, status, modalFun }) => {
    setApiResStatus(status);
    setApiResMessage(message);
    setCollectPaymentResponse(modalFun);
  };
  useEffect(() => {
    if (collectPaymentResponse !== null) {
      callRequestApi();
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  const handlePickupCancelRequest = (item) => {
    const storeCustomerId = item.pickupRequest.storeCustomerId;
    const updatedPickupRequest = {
      id: item.pickupRequest.id,
      storeId: storeId,
      storeCustomerId: storeCustomerId,
      pickupTimeSlot: item.pickupRequest.pickupTimeSlot,
      pickupOn: item.pickupRequest.pickupOn,
      pickupStatus:
        userRole === "BY_RIDER" ? "CANCEL_BY_RIDER" : "CANCEL_BY_STORE",
      remarks: "",
    };
    // Call the service function for updating pickup request
    updatePickupRequest(storeCustomerId, storeId, updatedPickupRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({
              message,
              status,
              modalFun: false,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeliveryCancelRequest = (item) => {
    const storeCustomerId = item.deliveryRequest.order.storeCustomerId;
    // Logic for updating a pickup request
    const updatedDeliveryRequest = {
      id: item.deliveryRequest.id,
      storeId: storeId,
      storeCustomerId: storeCustomerId,
      order: {
        id: item.deliveryRequest.order.id,
      },
      deliveryTimeSlot: item.deliveryRequest.deliveryTimeSlot,
      deliveryOn: item.deliveryRequest.deliveryOn,
      deliveryStatus:
        userRole === "BY_RIDER" ? "CANCEL_BY_RIDER" : "CANCEL_BY_STORE",
      remarks: "",
    };

    // Call the service function for updating pickup request
    updateDeliveryRequest(storeCustomerId, storeId, updatedDeliveryRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({ message, status, modalFun: false });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeliveryReturnRequest = (item) => {
    // Logic for updating a pickup request
    const updatedDeliveryRequest = {
      id: item.deliveryRequest.id,
      storeId: storeId,
      order: {
        id: item.deliveryRequest.order.id,
      },
      deliveryTimeSlot: item.deliveryRequest.deliveryTimeSlot,
      deliveryOn: item.deliveryRequest.deliveryOn,
      deliveryStatus: "RESCHEDULE_BY_RIDER",
      remarks: "",
    };

    // Call the service function for updating pickup request
    DeliveryReturnRequest(storeId, updatedDeliveryRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({ message, status, modalFun: false });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // const handlePhoneCall = (mobile) => {
  //   if (!mobile) {
  //     return alert("Mobile number is invalid");
  //   }
  //   const url = `tel:+91 ${mobile}`;

  //   // Linking.openURL(url)
  //   //   .then(() => alert('Phone Dial Opened successfully'))
  //   //   .catch(() => alert('Make sure Mobile Number is valid'));
  // };

  const handleLocation = (currentLocation, latitude, longitude) => {
    let url = "";
    if (currentLocation) {
      url = currentLocation;
    } else {
      url = `https://maps.google.com?q=${latitude},${longitude}`;
    }
    window.open(url);
  };

  const itemTemplate = (item, index) => {
    let formattedPickupDeliveryDate = "";
    let pickupDeliveryOn = "";
    let customerName = "";
    let customerMobile = "";
    let customerAddress = "";
    let pickupDeliveryTimeSlot = "";
    let riderFirstName = "";
    let riderLastName = "";
    let pickupDeliveryStatus = "";
    let pickupDeliveryOrderStatus = "";
    let pickupDeliveryRequestId = "";
    let storeCustomerId = "";
    let orderId = "";
    let orderNo = "";
    let invoiceNo = "";
    let createdDate = "";
    let createdDateWithTime = "";
    let currentLocation = "";
    let latitude = "";
    let longitude = "";
    let remarks = "";
    if (JobType == "pickup") {
      formattedPickupDeliveryDate = formatDate(item.pickupRequest.pickupOn);
      pickupDeliveryOn = item.pickupRequest.pickupOn;
      customerName = item.pickupRequest.customerName;
      customerMobile = item.pickupRequest.customerMobile;
      customerAddress = item.pickupRequest.customerAddress;
      pickupDeliveryTimeSlot = item.pickupRequest.pickupTimeSlot;
      riderFirstName = item.pickupRequest.rider.firstName;
      riderLastName = item.pickupRequest.rider.lastName;
      pickupDeliveryStatus = item.pickupRequest.pickupStatus;
      pickupDeliveryOrderStatus = "";
      pickupDeliveryRequestId = item.pickupRequest.id;
      storeCustomerId = item.pickupRequest.storeCustomerId;
      orderId = null;
      orderNo = null;
      invoiceNo = null;
      createdDate = formatDate(item.createdDate);
      createdDateWithTime = formatDateNewWithTime(item.createdDate);
      currentLocation = item.pickupRequest.addressDTO.currentLocation;
      latitude = item.pickupRequest.addressDTO.latitude;
      longitude = item.pickupRequest.addressDTO.longitude;
      remarks = item.pickupRequest.remarks;
    } else {
      formattedPickupDeliveryDate = formatDate(item.deliveryRequest.deliveryOn);
      pickupDeliveryOn = item.deliveryRequest.deliveryOn;
      customerName = item.deliveryRequest.order.customerName;
      customerMobile = item.deliveryRequest.order.customerMobile;
      customerAddress = item.deliveryRequest.order.customerAddress;
      pickupDeliveryTimeSlot = item.deliveryRequest.deliveryTimeSlot;
      riderFirstName = item.deliveryRequest.rider.firstName;
      riderLastName = item.deliveryRequest.rider.lastName;
      pickupDeliveryStatus = item.deliveryRequest.deliveryStatus;
      pickupDeliveryOrderStatus = item.deliveryRequest.order.status;
      pickupDeliveryRequestId = item.deliveryRequest.id;
      storeCustomerId = item.deliveryRequest.order.storeCustomerId;
      orderId = item.deliveryRequest.order.id;
      orderNo = item.deliveryRequest.order.orderNo;
      invoiceNo = item.deliveryRequest.order.invoiceNo;
      createdDate = formatDate(item.createdDate);
      createdDateWithTime = formatDateNewWithTime(item.createdDate);
      currentLocation = item.deliveryRequest.addressDTO.currentLocation;
      latitude = item.deliveryRequest.addressDTO.latitude;
      longitude = item.deliveryRequest.addressDTO.longitude;
      remarks = item.deliveryRequest.remarks;
    }
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": "#6EA4F5",
              fontSize: 10,
            }}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": "#6EA4F5",
          }}
          header={`${formattedPickupDeliveryDate} ${
            invoiceNo !== null ? " | " + invoiceNo : ""
            } | Rider - (${riderFirstName} ${riderLastName}) | Customer - (${customerName} ${maskMobileNumber(customerMobile)})`}
        >
          <div>
            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Created Date :
                </p>
                <p className="text-lg font-bold capitalize">{createdDateWithTime}</p>
              </div>

            </div>
            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Customer Details :
                </p>
                <p className="text-lg font-bold capitalize">{customerName}</p>
                  <p className="text-lg font-bold capitalize">{maskMobileNumber(customerMobile)}</p>
                <p className="text-lg font-bold capitalize">
                  {customerAddress}
                </p>
              </div>

              {(pickupDeliveryStatus !== "ORDER_BOOKED" && pickupDeliveryStatus !== "ORDER_CANCEL") && 
              <div className="flex col-6">
                <div
                  style={{
                    backgroundColor: "#008000",
                    borderWidth: 1,
                    borderColor: "#008000",
                    width: 35,
                    height: 35,
                    borderRadius: 5,
                  }}
                  className="flex justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                >
                  <a href={`tel:${customerMobile}`}>
                    <i
                      className="pi pi-phone"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    ></i>
                  </a>
                </div>
                <div>
                  {userRole === "BY_STORE" &&
                    pickupDeliveryStatus !== "OUT_FOR_DELIVERY" && (
                      <div>
                        <div
                          className="flex justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                          onClick={() =>
                            onEdit({
                              pickupDeliveryRequestData: {
                                id: pickupDeliveryRequestId,
                                storeCustomerId: storeCustomerId,
                                storeUserId: item.storeUserId,
                                pickupDeliveryTimeSlot: pickupDeliveryTimeSlot,
                                pickupOn: pickupDeliveryOn,
                                riderName: riderFirstName + riderLastName,
                                orderId: orderId,
                                pickupDeliveryStatus: pickupDeliveryStatus,
                                orderNo: orderNo,
                                invoiceNo: invoiceNo,
                                createdDate: createdDate,
                              },
                            })
                          }
                        >
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "30px",
                              cursor: "pointer",
                              color: "#008EFF",
                            }}
                          ></i>
                        </div>
                      </div>
                    )}
                </div>
                {(currentLocation || (latitude && longitude)) && (
                  <div>
                    <div
                      className="flex justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                      onClick={() =>
                        handleLocation(currentLocation, latitude, longitude)
                      }
                    >
                      <i
                        className="pi pi-map-marker
"
                        style={{
                          fontSize: "30px",
                          cursor: "pointer",
                          color: "red",
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                {JobType === "pickup" && (
                  <div>
                    { userRole !== "BY_SUPPORT_ADMIN" && (<div
                      className="cursor-pointer"
                      onClick={() =>
                        navigate("/BookNewOrder", {
                          state: {
                            storeCustomerId: storeCustomerId,
                          },
                        })
                      }
                    >
                      <div>
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                          }
                          style={{
                            width: 65,
                            height: 50,
                          }}
                        />
                      </div>
                    </div>)}
                  </div>
                )}

                {JobType === "pickup" && (
                  <div
                    className="  justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                    onClick={() => handlePickupCancelRequest(item)}
                  >
                    <div
                      className="py-1 px-2"
                      style={{
                        backgroundColor: "red",
                        borderRadius: 5,
                      }}
                    >
                      <p className="text-xl text-white font-bold capitalize">
                        Cancel
                      </p>
                    </div>
                  </div>
                )}
                {JobType !== "pickup" &&
                  pickupDeliveryStatus === "ASSIGNED_TO_RIDER" && (
                    <div
                      className="  justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                      onClick={() => handleDeliveryCancelRequest(item)}
                    >
                      <div
                        className="py-1 px-2"
                        style={{
                          backgroundColor: "red",
                          borderRadius: 5,
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: 15,
                            color: "#fff",
                            alignSelf: "center",
                          }}
                        >
                          Cancel
                        </p>
                      </div>
                    </div>
                  )}

                {JobType !== "pickup" &&
                  userRole === "BY_RIDER" &&
                  pickupDeliveryStatus === "OUT_FOR_DELIVERY" && (
                    <div
                      className="  justify-content-center align-items-center mx-4 my-2 cursor-pointer"
                      onClick={() => handleDeliveryReturnRequest(item)}
                    >
                      <div
                        className="py-1 px-2"
                        style={{
                          backgroundColor: "red",
                          borderRadius: 5,
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: 15,
                            color: "#fff",
                            alignSelf: "center",
                          }}
                        >
                          Return
                        </p>
                      </div>
                    </div>
                  )}
              </div>}
            </div>

            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Pickup Time Slot :
                </p>
                <p className="text-lg font-bold capitalize">
                  {pickupDeliveryTimeSlot}
                </p>
              </div>
              {JobType === "delivery" && (
                <div className="col-6">
                  <p className="text-base font-semiBold capitalize">
                    Invoice No. :
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {invoiceNo + " - " + createdDate}
                  </p>
                </div>
              )}
            </div>

            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Rider Details :
                </p>
                <p className="text-lg font-bold capitalize">
                  {riderFirstName} {riderLastName}
                </p>
              </div>

              <div className="col-6">
                <p className="text-base font-semiBold capitalize">Status :</p>
                <p className="text-lg font-bold capitalize">
                  {pickupDeliveryStatus.replace(/_/g, " ")}
                </p>
              </div>
            </div>
            {remarks && (
              <div className="flex-row">
                <div className="col-12">
                  <p className="text-base font-semiBold capitalize">Remark</p>
                  <p className="text-lg font-bold capitalize">{remarks}</p>
                </div>
              </div>
            )}
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  return (
    <div className="mx-4 my-2">
      <DataView
        value={orderInfoData}
        listTemplate={listTemplate}
        paginator
        rows={20}
      />

      {pickupRequestModalVisible && (
        <PickupRequest
          setPickupRequestModalVisible={setPickupRequestModalVisible}
          pickupRequestModalVisible={pickupRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          editMode={true}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={pickupDeliveryRequestData}
        />
      )}
      {deliveryRequestModalVisible && (
        <DeliveryRequest
          setDeliveryRequestModalVisible={setDeliveryRequestModalVisible}
          deliveryRequestModalVisible={deliveryRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          editMode={true}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={pickupDeliveryRequestData}
        />
      )}
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={apiResStatus === true ? "success" : false}
        text={apiResMessage}
      />
    </div>
  );
};

export default JobRequests;
